// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1U0jy","vLegacy":"SelectSecondary_vLegacy__2-gdD","error":"SelectSecondary_error__1ZE1z","disabled":"SelectSecondary_disabled__2lbG3"};